import React from "react";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import "./Admin.scss";
import { AdminstratorOptions } from "../../Utilities/Utility";
import cognisphere from "../../assets/images/HomePage-ImgNew.png";

export default function Admin() {
  return (
    <React.Fragment>
    <main className="main-component main-component1">
    {/* <img
      src={cognisphere}
      alt="Cognisphere"
      className="homepage-cognisphere"
    /> */}
      <h2 style={{color:"white"}}> Welcome to Administrator</h2>
      <Grid container className="Admin-block" spacing={2}>
       
                  {AdminstratorOptions.map((adminItem) => (
                      <Grid item xs={12} sm={4} key={adminItem.adminMenuId}>
                          <Link
                              to={adminItem.adminMenuLink}
                              className="animated-menu-link"
                          >
                              <div className="tool-banner">
                                  <div className="icon-box">
                                      {adminItem.adminIcon ? (
                                          adminItem.adminIcon
                                      ) : (
                                          <div>No Icon</div>
                                      )}
                                  </div>
                                  <div className="green-bar">
                                      <span className="menu-label">
                                          {adminItem.adminMenuName}
                                      </span>
                                  </div>
                              </div>
                          </Link>
                      </Grid>
                  ))}
      </Grid>
      </main>
    </React.Fragment>
  );
}